import React from 'react';
import Router from './Router';
import ComingSoon from './components/Sections/ComingSoon/ComingSoon';

const App = () => {
  return (
    // <Router />
    <ComingSoon />
  )
}

export default App